import api from './../helpers/api'


class PersonelService{    
    
    //create Department
    create_department(department){
        return api.post(`/add_department`,{
            name:department.name,
            description:department.description
        });
    }

    //get departments
    get_departments(){
        return api.get(`/get_departments`, );
    }

    delete_department(id){
        return api.post(`/delete_department`, { id });
    }

    //edit departments
    edit_department(department){
        return api.post(`/edit_department`,{
            id:department.id,
            name:department.name,
            description:department.description
        },);
    }

    delete_wharehouse(id){
        return api.post(`/delete/${id}`, );
    }

    //Personels
    create_personel(personel){
        return api.post(`/add_personel`,{
            names:             personel.names,
            id_card:           personel.id_card,
            position:          personel.position,
            contact:           personel.contact,
            salary:            personel.salary,
            department_id:     personel.department_id,
            address:           personel.address,
            status:            personel.status,
            start_date:        personel.start_date,
            emergency_contact: personel.emergency_contact,
            notes:             personel.notes,
        });
    }
    //get expenses category
    get_personels(){
        return api.get(`/get_personel`, );
    }

    edit_personel(personel){
        return api.post(`/edit_personel`, {
            id:                personel.id,
            names:             personel.names,
            id_card:           personel.id_card,
            position:          personel.position,
            contact:           personel.contact,
            salary:            personel.salary,
            department_id:     personel.department_id,
            address:           personel.address,
            status:            personel.status,
            start_date:        personel.start_date,
            emergency_contact: personel.emergency_contact,
            notes:             personel.notes,
        });
    }

    get_profile(id){
        return api.get(`/personel_profile/${id}`);
    }

    delete_personel(id){
        return api.post(`/delete_personel`, { id });
    }

    pay_personel(data){
        return api.post(`/pay_personel`, {
            personel_id:  data.personel_id,
            amount:       data.amount,
            period:       data.period,
            payment_type: data.payment_type || 'salary',
            note:         data.note,
        });
    }

    get_payment_history(id){
        return api.get(`/personel_payments/${id}`);
    }

    get_outstanding(period){
        return api.get(`/personel_outstanding`, { params: { period } });
    }

    pay_bulk(data){
        return api.post(`/pay_bulk`, {
            period:       data.period,
            personel_ids: data.personel_ids,
        });
    }

    get_leaves(personelId){
        return api.get(`/personel_leaves/${personelId}`);
    }

    add_leave(data){
        return api.post(`/add_leave`, data);
    }

    update_leave(id, data){
        return api.post(`/update_leave/${id}`, data);
    }

    delete_leave(id){
        return api.post(`/delete_leave/${id}`);
    }
}
export default new PersonelService;